// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  word-wrap: break-word !important;
}

:root {
  --lightgray:#f5f5f5;
  --black:#000000;
  --black2:#1F1F28;
  --white:#ffffff;
  --lightcolor:#838383;
  --border:#D9D9D9;
}

.filter--search {
  width: 100%;
  max-width: 500px;
}
@media (max-width: 767px) {
  .filter--search {
    max-width: 100%;
  }
}

.filter--search .filter--submit--btn {
  width: 100%;
  max-width: 120px;
}

.filter--search .filter--input--search {
  width: 100%;
}
.filter--search .filter--input--search .input--text {
  width: 100%;
}
.filter--search .filter--input--search .input--text:focus-visible {
  border: none;
  box-shadow: none;
  outline: none;
}
.filter--search .filter--input--search .css-b62m3t-container {
  max-width: 145px;
  width: 100%;
}
.filter--search .filter--input--search .css-b62m3t-container .css-13cymwt-control,
.filter--search .filter--input--search .css-b62m3t-container .css-t3ipsp-control {
  border: none;
  box-shadow: none;
}
.filter--search .filter--input--search .css-b62m3t-container:hover {
  border: none;
}
.filter--search .filter--input--search .css-b62m3t-container span.css-1u9des2-indicatorSeparator {
  display: none;
}

.modal--popupservice input:focus-visible,
.modal--popupservice textarea:focus-visible {
  box-shadow: none !important;
  border: none !important;
  outline: 1px solid #ccc;
}
.modal--popupservice .css-b62m3t-container .css-13cymwt-control,
.modal--popupservice .css-b62m3t-container .css-t3ipsp-control {
  border: 1px solid #ccc;
  box-shadow: none;
}
.modal--popupservice .css-b62m3t-container:hover {
  border: none;
}
.modal--popupservice .css-b62m3t-container span.css-1u9des2-indicatorSeparator {
  display: none;
}

.over--scroller::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.over--scroller::-webkit-scrollbar-track {
  background: transparent;
}
.over--scroller::-webkit-scrollbar-thumb {
  background: #888;
}
.over--scroller::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.custom--checkbox {
  position: relative;
}
.custom--checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 30px;
  width: 30px;
  left: 0;
  top: 0;
  z-index: 1;
}
.custom--checkbox .checkmark--custom {
  height: 30px;
  width: 30px;
  background-color: #E4E4E4;
  border-radius: 5px;
}
.custom--checkbox .checkmark--custom:after {
  content: "";
  position: absolute;
  display: none;
}
.custom--checkbox:hover input ~ .checkmark--custom {
  background-color: #ccc;
}
.custom--checkbox input:checked ~ .checkmark--custom {
  background-color: var(--black);
}
.custom--checkbox input:checked ~ .checkmark--custom:after {
  display: block;
}
.custom--checkbox .checkmark--custom:after {
  left: 11px;
  top: 6px;
  width: 8px;
  height: 14px;
  border: solid var(--white);
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

input.arrow--none::-webkit-outer-spin-button,
input.arrow--none::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.auto--fill--none input:-webkit-autofill,
.auto--fill--none input:-webkit-autofill:hover,
.auto--fill--none input:-webkit-autofill:focus,
.auto--fill--none input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

.chat--screen {
  position: fixed;
  bottom: 0px;
  right: 3%;
  height: 90%;
  width: 90% !important;
  max-width: 865px !important;
  animation: chatanimation 0.3s;
}

@keyframes chatanimation {
  from {
    transform: translateX(107%);
  }
  to {
    transform: translateX(0%);
  }
}
.logo--login {
  padding-left: 15px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login--form--admin:after {
  content: "";
  width: 100%;
  height: 100%;
  position: fixed;
  background: var(--white);
  left: 0;
  top: 0px;
}
.login--form--admin form {
  z-index: 1;
  position: relative;
  border: 1px solid #d5d5d5;
  padding: 42px 15px;
  border-radius: 15px;
  padding-bottom: 20px;
}

.heading--login {
  background: #fff;
  color: #000;
  width: 100%;
  max-width: 190px;
  margin: 0 auto;
  margin-bottom: -25px;
  z-index: 1;
  position: relative;
  border-radius: 5px;
  font-size: 17px;
  font-weight: 500;
  min-height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  line-height: normal;
  border: 1px solid #d5d5d5;
}

@media (max-width: 1024px) {
  .min-h {
    height: 40px;
  }
}

.pagination--container {
  position: fixed;
  bottom: 0px;
  width: calc(100% - 366px);
  right: 50px;
  padding: 10px 15px;
}
@media (max-width: 1024px) {
  .pagination--container {
    width: calc(100% - 162px);
    right: 50px;
  }
}
@media (max-width: 991px) {
  .pagination--container {
    width: calc(100% - 92px);
    right: 15px;
  }
}

body {
  font-family: "DM Sans", sans-serif;
  background: #dcdcdc;
}

.topbar--admin {
  padding: 17px 20px;
  background: var(--black);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--black);
  border-top: 0px;
  box-shadow: 2px 4px 7px -4px rgba(0, 0, 0, 0.0784313725);
  z-index: 2;
}
.topbar--admin .topbar--rightside ul {
  display: flex;
  align-items: center;
  gap: 10px;
}
.topbar--admin .topbar--rightside ul li.menu--item {
  background: #f5f5f5;
  padding: 6px;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  position: relative;
  border: 1px solid var(--white);
}
.topbar--admin .topbar--rightside ul li.menu--item:hover {
  color: var(--white);
  background-color: transparent;
}
.topbar--admin .topbar--rightside ul li.menu--item .profile--dropdown {
  position: absolute;
  background: var(--white);
  min-width: 150px;
  width: 100%;
  right: 0;
  border-radius: 5px;
  top: 100%;
  margin-top: 17px;
}
.topbar--admin .topbar--rightside ul li.menu--item .profile--dropdown ul {
  display: block;
  box-shadow: 0px 3px 5px 4px rgba(181, 181, 181, 0.1490196078);
}
.topbar--admin .topbar--rightside ul li.menu--item .profile--dropdown ul li {
  padding: 10px;
  width: 100%;
  transition: 0.3s;
  color: #1f1f28;
  border-bottom: 1px solid #ededed;
  font-size: 16px;
}
.topbar--admin .topbar--rightside ul li.menu--item .profile--dropdown ul li:hover {
  background: #f5f5f5;
}
.topbar--admin .topbar--rightside ul li.menu--item .profile--dropdown ul li:last-child {
  border: none;
}
.topbar--admin .topbar--rightside ul li.menu--item .bell--circle {
  width: 7px;
  aspect-ratio: 1;
  background: #000;
  border-radius: 50px;
  position: absolute;
  top: 5px;
  right: 6px;
  border: 1px solid #f5f5f5;
}
.topbar--admin .topbar--rightside ul .profile--info {
  line-height: normal;
}
.topbar--admin .topbar--rightside ul .profile--info small {
  font-size: 12px;
  color: #5f5e5e;
  font-weight: 700;
}

.notification--list {
  max-width: 293px;
  z-index: 333;
  right: 20px;
  padding: 0px;
  margin-top: 0px;
}
.notification--list ul {
  display: flex;
  flex-direction: column;
  gap: 10px;
  list-style: disc;
  padding: 20px 35px;
  z-index: 2;
  position: relative;
  background: #fff;
  border-radius: 10px;
  list-style: none;
}
.notification--list ul li {
  font-size: 14px;
  position: relative;
  padding-left: 15px;
}
.notification--list ul li:before {
  content: "";
  width: 5px;
  aspect-ratio: 1;
  background: #000;
  display: block;
  border-radius: 50px;
  min-width: 5px;
  position: absolute;
  top: 8px;
  left: 0px;
}
.notification--list ul .view--all--notifications {
  padding-left: 0px !important;
  text-align: center;
  padding-top: 15px;
  border-top: 1px solid #efefef;
  cursor: pointer;
}
.notification--list ul .view--all--notifications:before {
  display: none !important;
}
.notification--list:before {
  content: "";
  width: 26px;
  aspect-ratio: 1;
  background: #000;
  display: block;
  transform: rotate(45deg);
  position: absolute;
  top: -5px;
  right: 17%;
  z-index: 1;
}

.sidebar--menu {
  transition: 0.3s;
  position: sticky;
  top: 65px;
}
@media (max-width: 1024px) {
  .sidebar--menu {
    width: 62px;
    position: fixed;
    top: 65px;
    margin-top: 0px;
    background: var(--white);
    z-index: 3;
    padding: 8px;
  }
}
.sidebar--menu .top--logobar {
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 30px 5px;
  padding-top: 6px;
  position: relative;
}
.sidebar--menu .top--logobar .logo--sidebar {
  transition: 0.3s;
}
.sidebar--menu .top--logobar .toggle--bar {
  font-size: 30px;
  cursor: pointer;
  position: absolute;
  right: -25px;
  top: 0;
}
@media (max-width: 1024px) {
  .sidebar--menu .top--logobar .toggle--bar {
    transform: rotate(180deg);
    right: -18px;
  }
  .sidebar--menu .top--logobar .toggle--bar svg {
    width: 25px;
    height: 25px;
    padding: 7px;
  }
}
.sidebar--menu .login--details {
  color: var(--black);
  border-bottom: 1px solid var(--border);
}
.sidebar--menu .login--details .user--name {
  font-size: 20px;
  width: 270px;
}
.sidebar--menu .login--details .user--role {
  color: var(--lightcolor);
  width: 270px;
  font-size: 12px;
}
.sidebar--menu .login--details .single--name {
  background: var(--black);
  color: var(--white);
  border-radius: 50px;
  height: 45px;
  width: 45px;
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  padding: 10px;
}
@media (max-width: 1024px) {
  .sidebar--menu .login--details .single--name {
    display: flex;
  }
  .sidebar--menu .login--details .user--name, .sidebar--menu .login--details .user--role {
    display: none;
  }
}
.sidebar--menu .management--menu {
  border-bottom: 1px solid var(--border);
}
.sidebar--menu .management--menu .label--menu {
  color: var(--lightcolor);
  font-size: 12px;
  margin-bottom: 10px;
  padding-left: 12px;
}
@media (max-width: 1024px) {
  .sidebar--menu .management--menu .label--menu {
    display: none !important;
  }
}
.sidebar--menu .management--menu .menu--bar--list li a {
  width: 235px;
  transition: 0.3s;
  font-size: 14px;
  font-weight: 600;
  height: 40px;
}
@media (max-width: 1024px) {
  .sidebar--menu .management--menu .menu--bar--list li a {
    width: 45px;
    justify-content: center;
  }
}
.sidebar--menu .management--menu .menu--bar--list li a svg.menu--icon {
  font-size: 21px;
}
.sidebar--menu .management--menu .menu--bar--list li a:hover {
  background-color: var(--black2);
  color: var(--white);
}
.sidebar--menu .management--menu .menu--bar--list li a img {
  width: 28px;
  height: 28px;
}
.sidebar--menu .management--menu .menu--bar--list li a:hover img {
  filter: grayscale(0) invert(1);
  transition: 0.3s;
}
@media (max-width: 1024px) {
  .sidebar--menu .management--menu .menu--bar--list li a span {
    display: none;
  }
}
.sidebar--menu .management--menu .menu--bar--list li a.active {
  background: var(--black2);
  color: var(--white);
}
.sidebar--menu .management--menu .menu--bar--list li a.active img {
  filter: grayscale(0) invert(1);
  transition: 0.3s;
}
.sidebar--menu .management--menu .menu--bar--list li .dropdown--items {
  padding-top: 10px;
}
.sidebar--menu .management--menu .menu--bar--list li .dropdown--items li a {
  background: transparent;
  color: #000;
  padding: 3px 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.sidebar--menu .management--menu .menu--bar--list li .dropdown--items li a:after {
  content: "";
  width: 0%;
  height: 1px;
  background: #000;
  transition: 0.3s;
}
.sidebar--menu .management--menu .menu--bar--list li .dropdown--items li a:hover:after {
  width: 100%;
}

.active--toggle {
  width: 75px;
  transition: 0.3s;
}
@media (max-width: 1024px) {
  .active--toggle {
    width: 223px;
    box-shadow: 5px 0px 7px 2px rgba(0, 0, 0, 0.12);
    z-index: 333;
  }
}
.active--toggle .top--logobar {
  justify-content: center;
}
.active--toggle .top--logobar .logo--sidebar {
  width: 0px;
  transition: 0.3s;
}
.active--toggle .login--details .single--name {
  display: flex;
}
@media (max-width: 1024px) {
  .active--toggle .login--details .single--name {
    display: none;
  }
}
.active--toggle .login--details .user--name, .active--toggle .login--details .user--role {
  display: none;
}
@media (max-width: 1024px) {
  .active--toggle .login--details .user--name, .active--toggle .login--details .user--role {
    display: block;
  }
}
.active--toggle .management--menu {
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.active--toggle .management--menu .menu--bar--list li a {
  width: 45px;
  justify-content: center;
}
@media (max-width: 1024px) {
  .active--toggle .management--menu .menu--bar--list li a {
    width: 208px;
    justify-content: flex-start;
  }
}
.active--toggle .management--menu .menu--bar--list li a span {
  display: none;
  white-space: nowrap;
}
@media (max-width: 1024px) {
  .active--toggle .management--menu .menu--bar--list li a span {
    display: block;
  }
}
.active--toggle .management--menu .menu--bar--list li a .downarrow-menu {
  display: none;
}
.active--toggle .hide--content {
  display: none !important;
}
@media (max-width: 1024px) {
  .active--toggle .hide--content {
    display: block !important;
  }
  .side--content--area {
    height: calc(100vh - 65px);
    width: calc(100% - 62px);
  }
}

.action--btn .more--icon {
  font-size: 20px;
  color: #000;
}
.action--btn .action--dropdown {
  position: absolute;
  width: 125px;
  top: 100%;
  background: #fff;
  border-radius: 5px;
  z-index: 1;
  right: 0;
  margin-top: 9px;
  box-shadow: 0px 4px 24.1px 0px rgba(0, 0, 0, 0.15);
}
.action--btn .action--dropdown ul {
  display: flex;
  flex-direction: column;
}
.action--btn .action--dropdown ul li {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
  color: #000;
  cursor: pointer;
  padding: 10px 15px;
  transition: 0.3s;
}
.action--btn .action--dropdown ul li:hover {
  background: var(--lightgray);
}

@media (max-width: 991px) {
  .area--page {
    padding: 15px;
    padding-bottom: 0;
  }
}

.profile--info--work {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(185px, 1fr));
  gap: 5px;
  margin-bottom: 30px;
}
.profile--info--work .profile-info-item {
  border: 1px solid #efefef;
  padding: 15px;
  border-radius: 5px;
}
.profile--info--work .profile-info-item h5 {
  margin-bottom: 7px;
}
.profile--info--work .profile-info-item img {
  margin-bottom: 5px;
}

.profile-comments--item {
  border: 1px solid #efefef;
  padding: 5px;
  background: #fbfbfb;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/main.scss","webpack://./src/assets/scss/common/_color.scss","webpack://./src/assets/scss/common/_common.scss","webpack://./src/assets/scss/common/_typography.scss","webpack://./src/assets/scss/layout/_topbar.scss","webpack://./src/assets/scss/layout/_sidebar.scss","webpack://./src/assets/scss/pages/_categories.scss","webpack://./src/assets/scss/pages/_usersprofile.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;AACJ;;ACFA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;ADKJ;;AEXA;EACI,WAAA;EACA,gBAAA;AFcJ;AEZI;EAJJ;IAKQ,eAAA;EFeN;AACF;;AEZA;EACI,WAAA;EACA,gBAAA;AFeJ;;AEZA;EACI,WAAA;AFeJ;AEbI;EACI,WAAA;AFeR;AEbQ;EACI,YAAA;EACA,gBAAA;EACA,aAAA;AFeZ;AEXI;EACI,gBAAA;EACA,WAAA;AFaR;AEXQ;;EAEI,YAAA;EACA,gBAAA;AFaZ;AEVQ;EACI,YAAA;AFYZ;AETQ;EACI,aAAA;AFWZ;;AEGQ;;EACI,2BAAA;EACA,uBAAA;EACA,uBAAA;AFCZ;AEKQ;;EAEI,sBAAA;EACA,gBAAA;AFHZ;AEMQ;EACI,YAAA;AFJZ;AEOQ;EACI,aAAA;AFLZ;;AEWI;EACI,UAAA;EACA,WAAA;AFRR;AEWI;EACI,uBAAA;AFTR;AEYI;EACI,gBAAA;AFVR;AEaI;EACI,gBAAA;AFXR;;AEgBA;EACI,kBAAA;AFbJ;AEeI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;AFbR;AEgBI;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AFdR;AEgBQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AFdZ;AEkBI;EACI,sBAAA;AFhBR;AEmBI;EACI,8BAAA;AFjBR;AEoBI;EACI,cAAA;AFlBR;AEqBI;EACI,UAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,0BAAA;EACA,yBAAA;EAGA,wBAAA;AFnBR;;AEwBA;;EAEI,wBAAA;EACA,SAAA;AFrBJ;;AEyBI;;;;EAII,qDAAA;AFtBR;;AE2BA;EACI,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,6BAAA;AFxBJ;;AE2BA;EACI;IACI,2BAAA;EFxBN;EE2BE;IACI,yBAAA;EFzBN;AACF;AE4BA;EACI,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AF1BJ;;AE8BI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,OAAA;EACA,QAAA;AF3BR;AE8BI;EACI,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AF5BR;;AEgCA;EACI,gBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AF7BJ;;AEiCI;EADJ;IAEQ,YAAA;EF7BN;AACF;;AEgCA;EACI,eAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AF7BJ;AE+BI;EAPJ;IAQQ,yBAAA;IACJ,WAAA;EF5BF;AACF;AE8BI;EAZJ;IAaQ,wBAAA;IACJ,WAAA;EF3BF;AACF;;AG1OA;EACI,kCAAA;EACA,mBAAA;AH6OJ;;AI/OA;EACI,kBAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,wDAAA;EACA,UAAA;AJkPJ;AI9OQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AJgPZ;AI9OY;EACI,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AJgPhB;AI9OgB;EACI,mBAAA;EACA,6BAAA;AJgPpB;AI7OgB;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AJ+OpB;AI7OoB;EACI,cAAA;EACA,6DAAA;AJ+OxB;AI7OwB;EACI,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;AJ+O5B;AI7O4B;EACI,mBAAA;AJ+OhC;AI5O4B;EACI,YAAA;AJ8OhC;AIxOgB;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;AJ0OpB;AIjOY;EACI,mBAAA;AJmOhB;AIjOgB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AJmOpB;;AIpNA;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AJuNJ;AIrNI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AJuNR;AIrNQ;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;AJuNZ;AIrNY;EACI,WAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AJuNhB;AInNQ;EACI,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AJqNZ;AInNY;EACI,wBAAA;AJqNhB;AI9MI;EACI,WAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AJgNR;;AKtXA;EACI,gBAAA;EACA,gBAAA;EACA,SAAA;ALyXJ;AKvXI;EALJ;IAMQ,WAAA;IACA,eAAA;IACA,SAAA;IACA,eAAA;IACA,wBAAA;IACA,UAAA;IACA,YAAA;EL0XN;AACF;AKxXI;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AL0XR;AKvXQ;EACI,gBAAA;ALyXZ;AKtXQ;EACI,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;ALwXZ;AKtXY;EAPJ;IAQQ,yBAAA;IACA,YAAA;ELyXd;EKtXU;IAEQ,WAAA;IACA,YAAA;IACA,YAAA;ELyXlB;AANF;AK7WI;EACI,mBAAA;EACA,sCAAA;ALsXR;AKpXQ;EACI,eAAA;EACA,YAAA;ALsXZ;AKnXQ;EACI,wBAAA;EACA,YAAA;EACA,eAAA;ALqXZ;AKlXQ;EACI,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;ALoXZ;AKlXY;EAbJ;IAcQ,aAAA;ELqXd;EKjXM;IAEQ,aAAA;ELoXd;AAJF;AK3WI;EAEI,sCAAA;ALiXR;AK/WQ;EACI,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;ALiXZ;AK/WY;EANJ;IAOQ,wBAAA;ELkXd;AACF;AK7WgB;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AL+WpB;AK7WoB;EAPJ;IAQQ,WAAA;IACA,uBAAA;ELgXtB;AACF;AK9WoB;EACI,eAAA;ALgXxB;AK7WoB;EACI,+BAAA;EACA,mBAAA;AL+WxB;AK5WoB;EACI,WAAA;EACA,YAAA;AL8WxB;AK3WoB;EACI,8BAAA;EACA,gBAAA;AL6WxB;AKzWwB;EADJ;IAEQ,aAAA;EL4W1B;AACF;AKvWgB;EACI,yBAAA;EACA,mBAAA;ALyWpB;AKxWoB;EACI,8BAAA;EACA,gBAAA;AL0WxB;AKtWgB;EACI,iBAAA;ALwWpB;AKrWwB;EACI,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;ALuW5B;AKrW4B;EACI,WAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;ALuWhC;AKpW4B;EACI,WAAA;ALsWhC;;AKxVA;EACI,WAAA;EACA,gBAAA;AL2VJ;AKzVI;EAJJ;IAKQ,YAAA;IACA,+CAAA;IACA,YAAA;EL4VN;AACF;AK1VI;EACI,uBAAA;AL4VR;AK1VQ;EACI,UAAA;EACA,gBAAA;AL4VZ;AKvVQ;EACI,aAAA;ALyVZ;AKvVY;EAHJ;IAIQ,aAAA;EL0Vd;AACF;AKxVQ;EACI,aAAA;AL0VZ;AKxVY;EAHJ;IAIQ,cAAA;EL2Vd;AACF;AKvVI;EAEI,oBAAA;EACA,mBAAA;ALwVR;AKpVgB;EACI,WAAA;EACA,uBAAA;ALsVpB;AKpVoB;EAJJ;IAKQ,YAAA;IACA,2BAAA;ELuVtB;AACF;AKrVoB;EACI,aAAA;EACA,mBAAA;ALuVxB;AKrVwB;EAJJ;IAKQ,cAAA;ELwV1B;AACF;AKpVoB;EACI,aAAA;ALsVxB;AK9UI;EACI,wBAAA;ALgVR;AK9UQ;EAHJ;IAIQ,yBAAA;ELiVV;EK1UF;IAEQ,0BAAA;IACA,wBAAA;EL8UN;AANF;;AM1lBI;EACI,eAAA;EACA,WAAA;ANomBR;AMlmBI;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;EACA,kDAAA;ANomBR;AMlmBQ;EACI,aAAA;EACA,sBAAA;ANomBZ;AMlmBY;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ANomBhB;AMlmBgB;EACI,4BAAA;ANomBpB;;AM5lBI;EADJ;IAEQ,aAAA;IACA,iBAAA;ENgmBN;AACF;;AO1oBA;EACI,aAAA;EACA,2DAAA;EACA,QAAA;EACA,mBAAA;AP6oBJ;AO3oBI;EACI,yBAAA;EACA,aAAA;EACA,kBAAA;AP6oBR;AO3oBQ;EACI,kBAAA;AP6oBZ;AO1oBQ;EACI,kBAAA;AP4oBZ;;AOvoBA;EACI,yBAAA;EACA,YAAA;EACA,mBAAA;AP0oBJ","sourcesContent":["* {\n    word-wrap: break-word !important;\n}\n\n@import './common/index.scss';\n@import './layout/index.scss';\n@import './pages/index.scss';",":root{\n    --lightgray:#f5f5f5;\n    --black:#000000;\n    --black2:#1F1F28;\n    --white:#ffffff;\n    --lightcolor:#838383;\n    --border:#D9D9D9;\n}",".filter--search {\n    width: 100%;\n    max-width: 500px;\n\n    @media(max-width: 767px) {\n        max-width: 100%;\n    }\n}\n\n.filter--search .filter--submit--btn {\n    width: 100%;\n    max-width: 120px;\n}\n\n.filter--search .filter--input--search {\n    width: 100%;\n\n    .input--text {\n        width: 100%;\n\n        &:focus-visible {\n            border: none;\n            box-shadow: none;\n            outline: none;\n        }\n    }\n\n    .css-b62m3t-container {\n        max-width: 145px;\n        width: 100%;\n\n        .css-13cymwt-control,\n        .css-t3ipsp-control {\n            border: none;\n            box-shadow: none;\n        }\n\n        &:hover {\n            border: none;\n        }\n\n        span.css-1u9des2-indicatorSeparator {\n            display: none;\n        }\n    }\n\n    // .search--icon {\n    //     width: 50px;\n    // }\n\n}\n\n.modal--popupservice {\n\n    input,\n    textarea {\n        &:focus-visible {\n            box-shadow: none !important;\n            border: none !important;\n            outline: 1px solid #ccc;\n        }\n    }\n\n    .css-b62m3t-container {\n\n        .css-13cymwt-control,\n        .css-t3ipsp-control {\n            border: 1px solid #ccc;\n            box-shadow: none;\n        }\n\n        &:hover {\n            border: none;\n        }\n\n        span.css-1u9des2-indicatorSeparator {\n            display: none;\n        }\n    }\n}\n\n.over--scroller {\n    &::-webkit-scrollbar {\n        width: 5px;\n        height: 5px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: #888;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n        background: #555;\n    }\n}\n\n\n.custom--checkbox {\n    position: relative;\n\n    & input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 30px;\n        width: 30px;\n        left: 0;\n        top: 0;\n        z-index: 1;\n    }\n\n    .checkmark--custom {\n        height: 30px;\n        width: 30px;\n        background-color: #E4E4E4;\n        border-radius: 5px;\n\n        &:after {\n            content: \"\";\n            position: absolute;\n            display: none;\n        }\n    }\n\n    &:hover input~.checkmark--custom {\n        background-color: #ccc;\n    }\n\n    & input:checked~.checkmark--custom {\n        background-color: var(--black);\n    }\n\n    & input:checked~.checkmark--custom:after {\n        display: block;\n    }\n\n    & .checkmark--custom:after {\n        left: 11px;\n        top: 6px;\n        width: 8px;\n        height: 14px;\n        border: solid var(--white);\n        border-width: 0 3px 3px 0;\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n    }\n}\n\n\ninput.arrow--none::-webkit-outer-spin-button,\ninput.arrow--none::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.auto--fill--none {\n    input:-webkit-autofill,\n    input:-webkit-autofill:hover,\n    input:-webkit-autofill:focus,\n    input:-webkit-autofill:active {\n        -webkit-box-shadow: 0 0 0 30px white inset !important;\n\n    }\n}\n\n.chat--screen {\n    position: fixed;\n    bottom: 0px;\n    right: 3%;\n    height: 90%;\n    width: 90% !important;\n    max-width: 865px !important;\n    animation: chatanimation 0.3s;\n}\n\n@keyframes chatanimation {\n    from {\n        transform: translateX(calc(100% + 7%))\n    }\n\n    to {\n        transform: translateX(0%)\n    }\n}\n\n.logo--login {\n    padding-left: 15px;\n    padding-bottom: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.login--form--admin {\n    &:after {\n        content: '';\n        width: 100%;\n        height: 100%;\n        position: fixed;\n        background: var(--white);\n        left: 0;\n        top: 0px;\n    }\n\n    form {\n        z-index: 1;\n        position: relative;\n        border: 1px solid #d5d5d5;\n        padding: 42px 15px;\n        border-radius: 15px;\n        padding-bottom: 20px;\n    }\n}\n\n.heading--login{\n    background: #fff;\n    color: #000;\n    width: 100%;\n    max-width: 190px;\n    margin: 0 auto;\n    margin-bottom: -25px;\n    z-index: 1;\n    position: relative;\n    border-radius: 5px;\n    font-size: 17px;\n    font-weight: 500;\n    min-height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px;\n    line-height: normal;\n    border: 1px solid #d5d5d5;\n}\n\n.min-h{\n    @media(max-width:1024px){\n        height: 40px;\n    }\n}\n\n.pagination--container {\n    position: fixed;\n    bottom: 0px;\n    width: calc(100% - 366px);\n    right: 50px;\n    padding: 10px 15px;\n\n    @media(max-width:1024px){\n        width: calc(100% - 162px);\n    right: 50px;\n    }\n\n    @media(max-width:991px){\n        width: calc(100% - 92px);\n    right: 15px;\n    }\n}","body{\n    font-family: 'DM Sans', sans-serif;\n    background: #dcdcdc;\n}",".topbar--admin {\n    padding: 17px 20px;\n    background: var(--black);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid var(--black);\n    border-top: 0px;\n    box-shadow: 2px 4px 7px -4px #00000014;\n    z-index: 2;\n\n\n    .topbar--rightside {\n        ul {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n\n            li.menu--item {\n                background: #f5f5f5;\n                padding: 6px;\n                border-radius: 5px;\n                cursor: pointer;\n                transition: 0.3s;\n                position: relative;\n                border: 1px solid var(--white);\n\n                &:hover {\n                    color: var(--white);\n                    background-color: transparent;\n                }\n\n                .profile--dropdown {\n                    position: absolute;\n                    background: var(--white);\n                    min-width: 150px;\n                    width: 100%;\n                    right: 0;\n                    border-radius: 5px;\n                    top: 100%;\n                    margin-top: 17px;\n\n                    ul {\n                        display: block;\n                        box-shadow: 0px 3px 5px 4px #b5b5b526;\n\n                        li {\n                            padding: 10px;\n                            width: 100%;\n                            transition: 0.3s;\n                            color: #1f1f28;\n                            border-bottom: 1px solid #ededed;\n                            font-size: 16px;\n\n                            &:hover {\n                                background: #f5f5f5;\n                            }\n\n                            &:last-child {\n                                border: none;\n                            }\n                        }\n                    }\n                }\n\n                .bell--circle {\n                    width: 7px;\n                    aspect-ratio: 1;\n                    background: #000;\n                    border-radius: 50px;\n                    position: absolute;\n                    top: 5px;\n                    right: 6px;\n                    border: 1px solid #f5f5f5;\n                }\n            }\n\n            // li.active--menu {\n            //     background-color: #000;\n            //     color: #fff;\n            // }\n\n            .profile--info {\n                line-height: normal;\n\n                small {\n                    font-size: 12px;\n                    color: #5f5e5e;\n                    font-weight: 700;\n                }\n            }\n        }\n    }\n}\n\n// .active--toggle ~ div > .topbar--admin > .logo--topbar {\n//     visibility: visible;\n// }\n\n// .active--toggle ~ div > .topbar--admin {\n//     justify-content: space-between;\n// }\n\n.notification--list {\n    max-width: 293px;\n    z-index: 333;\n    right: 20px;\n    padding: 0px;\n    margin-top: 0px;\n\n    ul {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        list-style: disc;\n        padding: 20px 35px;\n        z-index: 2;\n        position: relative;\n        background: #fff;\n        border-radius: 10px;\n        list-style: none;\n\n        li {\n            font-size: 14px;\n            position: relative;\n            padding-left: 15px;\n\n            &:before {\n                content: '';\n                width: 5px;\n                aspect-ratio: 1;\n                background: #000;\n                display: block;\n                border-radius: 50px;\n                min-width: 5px;\n                position: absolute;\n                top: 8px;\n                left: 0px;\n            }\n        }\n\n        .view--all--notifications {\n            padding-left: 0px !important;\n            text-align: center;\n            padding-top: 15px;\n            border-top: 1px solid #efefef;\n            cursor: pointer;\n\n            &:before {\n                display: none !important;\n            }\n        }\n\n\n    }\n\n    &:before {\n        content: '';\n        width: 26px;\n        aspect-ratio: 1;\n        background: #000;\n        display: block;\n        transform: rotate(45deg);\n        position: absolute;\n        top: -5px;\n        right: 17%;\n        z-index: 1;\n    }\n}",".sidebar--menu {\n    transition: 0.3s;\n    position: sticky;\n    top: 65px;\n\n    @media(max-width:1024px){\n        width: 62px;\n        position: fixed;\n        top: 65px;\n        margin-top: 0px;\n        background: var(--white);\n        z-index: 3;\n        padding: 8px;\n    }\n\n    .top--logobar {\n        display: flex;\n        justify-content: end;\n        align-items: center;\n        padding: 30px 5px;\n        padding-top: 6px;\n        position: relative;\n\n\n        .logo--sidebar {\n            transition: 0.3s;\n        }\n\n        .toggle--bar {\n            font-size: 30px;\n            cursor: pointer;\n            position: absolute;\n            right: -25px;\n            top: 0;\n\n            @media(max-width:1024px){\n                transform: rotate(180deg);\n                right: -18px;\n            }\n\n            svg{\n                @media(max-width:1024px){\n                    width: 25px;\n                    height: 25px;\n                    padding: 7px;\n                }\n            }\n        }\n    }\n\n    .login--details {\n        color: var(--black);\n        border-bottom: 1px solid var(--border);\n\n        .user--name {\n            font-size: 20px;\n            width: 270px;\n        }\n\n        .user--role {\n            color: var(--lightcolor);\n            width: 270px;\n            font-size: 12px;\n        }\n\n        .single--name {\n            background: var(--black);\n            color: var(--white);\n            border-radius: 50px;\n            height: 45px;\n            width: 45px;\n            display: none;\n            align-items: center;\n            justify-content: center;\n            font-size: 22px;\n            font-weight: 500;\n            padding: 10px;\n\n            @media(max-width:1024px){\n                display:flex;\n            }\n        }\n\n        .user--name, .user--role{\n            @media(max-width:1024px){\n                display:none;\n            }\n        }\n    }\n\n    .management--menu {\n\n        border-bottom: 1px solid var(--border);\n\n        .label--menu {\n            color: var(--lightcolor);\n            font-size: 12px;\n            margin-bottom: 10px;\n            padding-left: 12px;\n\n            @media(max-width:1024px){\n                display: none !important;\n            }\n        }\n\n        .menu--bar--list {\n            li {\n                a {\n                    width: 235px;\n                    transition: 0.3s;\n                    font-size: 14px;\n                    font-weight: 600;\n                    height: 40px;\n\n                    @media(max-width:1024px){\n                        width: 45px;\n                        justify-content: center;\n                    }\n\n                    svg.menu--icon {\n                        font-size: 21px;\n                    }\n\n                    &:hover {\n                        background-color: var(--black2);\n                        color: var(--white);\n                    }\n\n                    img {\n                        width: 28px;\n                        height: 28px;\n                    }\n\n                    &:hover img {\n                        filter: grayscale(0) invert(1);\n                        transition: 0.3s;\n                    }\n\n                    span{\n                        @media(max-width:1024px){\n                            display:none;\n                        }\n                    }\n                    \n                }\n\n                a.active {\n                    background: var(--black2);\n                    color: var(--white);\n                    img {\n                        filter: grayscale(0) invert(1);\n                        transition: 0.3s;\n                    }\n                }\n\n                .dropdown--items {\n                    padding-top: 10px;\n\n                    li {\n                        a {\n                            background: transparent;\n                            color: #000;\n                            padding: 3px 15px;\n                            display: flex;\n                            flex-direction: column;\n                            align-items: flex-start;\n\n                            &:after {\n                                content: '';\n                                width: 0%;\n                                height: 1px;\n                                background: #000;\n                                transition: 0.3s;\n                            }\n\n                            &:hover:after {\n                                width: 100%;\n                            }\n\n                           \n                            \n                        }\n                    }\n                }\n            }\n        }\n\n    }\n}\n\n.active--toggle {\n    width: 75px;\n    transition: 0.3s;\n\n    @media(max-width:1024px){\n        width: 223px;\n        box-shadow: 5px 0px 7px 2px rgb(0 0 0 / 12%);\n        z-index: 333;\n    }\n\n    .top--logobar {\n        justify-content: center;\n\n        .logo--sidebar {\n            width: 0px;\n            transition: 0.3s;\n        }\n    }\n\n    .login--details {\n        .single--name{\n            display: flex;\n\n            @media(max-width:1024px){\n                display:none;\n            }\n        }\n        .user--name, .user--role{\n            display:none;\n\n            @media(max-width:1024px){\n                display:block;\n            }\n        }\n    }\n\n    .management--menu {\n\n        padding-bottom: 15px;\n        margin-bottom: 15px;\n\n        .menu--bar--list {\n            li {\n                a {\n                    width: 45px;\n                    justify-content: center;\n\n                    @media(max-width:1024px){\n                        width: 208px;\n                        justify-content: flex-start;\n                    }\n\n                    span{\n                        display: none;\n                        white-space: nowrap;\n\n                        @media(max-width:1024px){\n                            display:block;\n                        }\n                    }\n\n\n                    .downarrow-menu {\n                        display: none;\n                    }\n                }\n            }\n        }\n\n    }\n\n    .hide--content {\n        display: none !important;\n\n        @media(max-width:1024px){\n            display: block !important;\n        }\n    }\n\n}\n\n\n.side--content--area{\n    @media(max-width:1024px){\n        height: calc(100vh - 65px);\n        width: calc(100% - 62px);\n    }\n}",".action--btn {\n    .more--icon{\n        font-size: 20px;\n        color: #000;\n    }\n    .action--dropdown {\n        position: absolute;\n        width: 125px;\n        top: 100%;\n        background: #fff;\n        border-radius: 5px;\n        z-index: 1;\n        right: 0;\n        margin-top: 9px;\n        box-shadow: 0px 4px 24.1px 0px rgba(0, 0, 0, 0.15);\n\n        ul {\n            display: flex;\n            flex-direction: column;\n\n            li {\n                display: flex;\n                gap: 10px;\n                align-items: center;\n                font-size: 14px;\n                color: #000;\n                cursor: pointer;\n                padding: 10px 15px;\n                transition: 0.3s;\n\n                &:hover {\n                    background: var(--lightgray);\n                }\n            }\n        }\n    }\n}\n\n.area--page{\n    @media(max-width:991px){\n        padding: 15px;\n        padding-bottom: 0;\n    }\n}",".profile--info--work{\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(185px, 1fr));\n    gap: 5px;\n    margin-bottom: 30px;\n\n    .profile-info-item {\n        border: 1px solid #efefef;\n        padding: 15px;\n        border-radius: 5px;\n\n        h5 {\n            margin-bottom: 7px;\n        }\n\n        img {\n            margin-bottom: 5px;\n        }\n    }\n}\n\n.profile-comments--item {\n    border: 1px solid #efefef;\n    padding: 5px;\n    background: #fbfbfb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
